module.exports = __webpack_public_path__ + "img/close.a0b357a5.svg";